import { render, staticRenderFns } from "./DashboardDetailModal.vue?vue&type=template&id=3e0c7981&scoped=true&"
import script from "./DashboardDetailModal.vue?vue&type=script&lang=js&"
export * from "./DashboardDetailModal.vue?vue&type=script&lang=js&"
import style0 from "./DashboardDetailModal.vue?vue&type=style&index=0&id=3e0c7981&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e0c7981",
  null
  
)

export default component.exports